export const EventHeaders = {
    ReadyToSendCount: 'X-ReadyToSend-Count',
    WaitingToRetryCount: 'X-WaitingToRetry-Count',
    SendingCount: 'X-Sending-Count',
    ErrorCount: 'X-Error-Count',
    SentCount: 'X-Sent-Count',
    OpenedCount: 'X-Opened-Count',
    ClickedCount: 'X-Clicked-Count',
    UnsubscribedCount: 'X-Unsubscribed-Count',
    AbuseReportCount: 'X-AbuseReport-Count',
    IgnoreCount: 'X-Ignore-Count',
    SpamCount: 'X-Spam-Count',
    BlackListedCount: 'X-BlackListed-Count',
    NoMailboxCount: 'X-NoMailbox-Count',
    GreyListedCount: 'X-GreyListed-Count',
    ThrottledCount: 'X-Throttled-Count',
    TimeoutCount: 'X-Timeout-Count',
    ConnectionProblemCount: 'X-ConnectionProblem-Count',
    SPFProblemCount: 'X-SPFProblem-Count',
    AccountProblemCount: 'X-AccountProblem-Count',
    DNSProblemCount: 'X-DNSProblem-Count',
    NotDeliveredCancelledCount: 'X-NotDeliveredCancelled-Count',
    CodeErrorCount: 'X-CodeError-Count',
    ManualCancelCount: 'X-ManualCancel-Count',
    ConnectionTerminatedCount: 'X-ConnectionTerminated-Count',
    NotDeliveredCount: 'X-NotDelivered-Count',
};

export const SoftHeaders = {
    SoftGreyListedCount: 'X-Soft-GreyListed-Count',
    SoftThrottledCount: 'X-Soft-Throttled-Count',
    SoftTimeoutCount: 'X-Soft-Timeout-Count',
    SoftConnectionProblemCount: 'X-Soft-ConnectionProblem-Count',
    SoftSPFProblemCount: 'X-Soft-SPFProblem-Count',
    SoftDNSProblemCount: 'X-Soft-DNSProblem-Count',
    SoftCodeError: 'X-Soft-CodeError-Count',
    SoftConnectionTerminatedCount: 'X-Soft-ConnectionTerminated-Count',
};

export const HardEventHeaders = {
    IgnoreCount: 'X-Hard-Ignore-Count',
    SpamCount: 'X-Hard-Spam-Count',
    BlackListedCount: 'X-Hard-BlackListed-Count',
    NoMailboxCount: 'X-Hard-NoMailbox-Count',
    AccountProblemCount: 'X-Hard-AccountProblem-Count',
    NotDeliveredCancelledCount: 'X-Hard-NotDeliveredCancelled-Count',
    ManualCancelCount: 'X-Hard-ManualCancel-Count',
    NotDeliveredCount: 'X-Hard-NotDelivered-Count',
};

export const TotalEventHeaders = {
    TotalCount: 'x-total-count',
    ActiveCount: 'x-total-active-count',
    SendingCount: 'x-total-sending-count',
    DeletedCount: 'x-total-deleted-count',
    CompletedCount: 'x-total-completed-count',
    PausedCount: 'x-total-paused-count',
    CancelledCount: 'x-total-cancelled-count',
    ErrorCount: 'x-total-error-count',
    SentCount: 'x-total-sent-count',
    GreylistedCount: 'x-total-greylisted-count',
    IgnoreCount: 'x-total-ignore-count',
    OpenedCount: 'x-total-opened-count',
    ClickedCount: 'x-total-clicked-count',
    AbuseReportCount: 'x-total-abuseReport-count',
    UnsubscribedCount: 'x-total-unsubscribed-count',
    ReadytosendCount: 'x-total-readytosend-count',
    AllCount: 'x-total-all-count',
    WaitingtoretryCount: 'x-total-waitingtoretry-count',
    DraftCount: 'x-total-draft-count',
    UnknownCount: 'x-total-unknown-count',
    AccountproblemCount: 'x-total-accountproblem-count',
    BlacklistedCount: 'x-total-blacklisted-count',
    CodeerrorCount: 'x-total-codeerror-count',
    ConnectionproblemCount: 'x-total-connectionproblem-count',
    ConnectionterminatedCount: 'x-total-connectionterminated-count',
    DnsproblemCount: 'x-total-dnsproblem-count',
    ManualcancelCount: 'x-total-manualcancel-count',
    NomailboxCount: 'x-total-nomailbox-count',
    NotdeliveredCount: 'x-total-notdelivered-count',
    NotdeliveredcancelledCount: 'x-total-notdeliveredcancelled-count',
    SpamCount: 'x-total-spam-count',
    SpfproblemCount: 'x-total-spfproblem-count',
    ThrottledCount: 'x-total-throttled-count',
    TimeoutCount: 'x-total-timeout-count',
    Processing: 'x-total-processing-count',
};

export enum TotalContactHeaders {
    TotalCount = 'x-total-count',
    ActiveCount = 'x-total-active-count',
    BouncedCount = 'x-total-bounced-count',
    AbuseCount = 'x-total-abuse-count',
    InactiveCount = 'x-total-inactive-count',
    StaleCount = 'x-total-stale-count',
    UnsubscribedCount = 'x-total-unsubscribed-count',
    TransactionalCount = 'x-total-transactional-count',
    EngagedCount = 'x-total-engaged-count',
    NotconfirmedCount = 'x-total-notconfirmed-count',
}

export const AutomationsHeaders = {
    TotalCount: 'x-total-count',
    InvalidCount: 'x-total-invalid-count',
    DraftCount: 'x-total-inactive-count',
    PausedCount: 'x-total-paused-count',
    ActiveCount: 'x-total-active-count',
};

export const FormsHeaders = {
    TotalEmbeddedCount: 'x-total-private-embedded-count',
    TotalFormcreatorCount: 'x-total-private-formcreator-count',
    TotalGlobalCount: 'x-total-global-count',
}